/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AuditLogAction {
    INSERT = 'insert',
    UPDATE = 'update',
    DELETE = 'delete',
    IMPERSONATION_START = 'impersonation_start',
}
